/**
 * Whether any of the plan's insurances has been submitted. The policies live
 * on the user (user.userHealthInsurances); the plan lists which are its own
 * in userHealthInsuranceIds.
 */
export default function planHasSubmittedInsurance(user, plan) {
  const ids = plan?.userHealthInsuranceIds || [];
  return (user?.userHealthInsurances || []).some(
    (ins) => ids.includes(ins.id) && ins?.submittedTs,
  );
}